import {CustomLevelCardStyle} from "../../../../components/Styles";
import {FIELD_TYPE, FIELD_TYPES_MODEL} from "../../../Dashboard/Visitor/Type/Model/Model";
import CustomChip from "../../../../components/CustomChip";
import {colors} from "../../../../enums/colors";
import {
    DATE_TIME_FORMAT_NAME_MODEL, downloadActionFile, downloadLocalFile,
    EMPTY_VALUES, formatBytes, getDateFormat
} from "../../../../Apis/functions";
import {
    chipStatusClassColor,
    chipStatusIconClassColor,
    statusBorderColor,
    statusColor,
    statusFontColor
} from "../../../../enums/statusColorEnum";
import {status, STATUS_MODEL} from "../../../../enums/statusEnum";
import {
    CloseIcon,
    DownloadIcon, IconClip,
    IconFileEmpty, IconInfoCard,
    IconLine,
    UpdateIcon
} from "../../../../components/buttons/IconButtons";
import CustomFileCard from "../../../../components/CustomFileCard";
import CustomUserChip from "../../../../components/CustomUserChip";
import {POSITION_MODEL} from "../../../../Helpers/PositionModel";
import React, {useState} from "react";
import ButtonSubAction from "../../../../components/buttons/ButtonSubAction";
import {CustomTextField} from "../../../../components/CustomTextField";
import {REQUEST_DOCUMENTATION_BADGE_MODEL, REQUEST_DOCUMENTATION_ICON_MODEL} from "../Model/Model";
import {getFileIcon, getFileNameWithoutExtension} from "../../../../Helpers/fileType";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import CustomTooltip from "../../../../components/CustomTooltip";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 09/12/2025
 */

const LevelRequestCard = ({
                              item,
                              index,
                              disabled,
                              t,
                              handleChange,
                              emptyFields,
                              setShowModal,
                              due,
                              setActiveLevelIndex,
                              highlightedLevel
                          }) => {

    const [showBadgeMessage, setShowBadgeMessage] = useState(true);
    const handleCloseBadge = () => {
        setShowBadgeMessage(false);
    }
    const statusUserLevelId = item?.userLevel?.statusId ?? STATUS_MODEL.PENDING;
    let styles = CustomLevelCardStyle( statusUserLevelId, disabled);
    const IconComponent = REQUEST_DOCUMENTATION_ICON_MODEL[statusUserLevelId];
    const iconBadge = REQUEST_DOCUMENTATION_BADGE_MODEL[statusUserLevelId];

    const fieldTypes = FIELD_TYPES_MODEL();
    const fieldTypeData = fieldTypes.find((ft) => ft.id === item.type);
    const IconDocument = fieldTypeData?.icon;
    const legend = fieldTypeData?.name;
    const isText = item.type === FIELD_TYPE.TEXT.name;
    const isFile = item.type === FIELD_TYPE.DOCUMENT.name;
    const hasApproved = Boolean(item?.userLevel?.approverFullName?.trim());

    return (
        <>
            { showBadgeMessage && statusUserLevelId !== STATUS_MODEL.PENDING_REVIEW && item?.userLevel?.reason &&
                <div className={'col-12 p-0'}>
                    <CustomUserChip
                        name={item?.userLevel?.reason || "documentation_approve"}
                        Icon={iconBadge}
                        showAvatar={true}
                        className={`${chipStatusClassColor[statusUserLevelId]} w-100 m-0 px-1 py-12px justify-content-start position-static border-radius-top-8px`}
                        classNameText={"m-1"}
                        classNameBoxText={"px-1"}
                        classNameIcon="w-h-24px"
                        variant='large'
                        iconPosition={POSITION_MODEL.LEFT}
                        onDelete={() => handleCloseBadge() }
                        deleteIcon={<CloseIcon height={16} width={16} className={`${chipStatusIconClassColor[statusUserLevelId]}`}/>}
                    />
                </div>
            }
            <div className='d-flex justify-content-start mb-5'>
                <div className={`transition-all ${item?.userLevel?.reason && "border-radius-bottom"}
                ${highlightedLevel === index && 'border-full-secondary-150 border-radius-8px'}`} style={styles.container}>
                    <div style={styles.levelCard} className={"d-flex justify-content-between"}>
                        <div>
                            <div className='d-flex justify-content-start align-items-center gap-2'>
                                <p style={styles.level}>{item?.name}</p>
                                <div><IconLine className="h-16px icon-color-shades-500" /></div>
                                <CustomChip
                                    icon={<IconDocument className={"icon-color-secondary-700"}/>}
                                    background={colors.secondary100}
                                    fontColor={colors.secondary700}
                                    borderColor={colors.secondary150}
                                    legend={legend || EMPTY_VALUES.DEFAULT}
                                />
                            </div>
                            {hasApproved &&
                                <div className='d-flex justify-content-between align-items-center'>
                                    <div className='d-flex align-items-center'>
                                        <p className={"fs-12px font-color-shades-600 ibl-font-w-300"}>
                                            {
                                                [STATUS_MODEL.APPROVED].includes(statusUserLevelId) ? t("approved_by")
                                                    + ": " + item?.userLevel?.approverFullName :
                                                    t("changes_requested_by")
                                                    + ": " + item?.userLevel?.approverFullName
                                            }
                                        </p>
                                    </div>
                                </div>
                            }
                            <div>
                                {item?.userLevel?.decisionDate ?
                                    <p className={"fs-12px font-color-shades-600 ibl-font-w-300"}>
                                        {getDateFormat(item?.userLevel?.decisionDate,false , DATE_TIME_FORMAT_NAME_MODEL.dateTime24Hour)}
                                    </p>
                                    :
                                    <p className={"fs-12px font-color-shades-600 ibl-font-w-300"}>
                                        {t("due_in") +" "+ due + " " + t("days")}
                                    </p>
                                }
                            </div>
                        </div>
                        <div>
                            <div className='d-flex-end'>
                                <CustomChip
                                    variant='large'
                                    icon={<IconComponent className={`${chipStatusIconClassColor[statusUserLevelId]}`}/>}
                                    background={statusColor[statusUserLevelId]}
                                    fontColor={statusFontColor[statusUserLevelId]}
                                    borderColor={statusBorderColor[statusUserLevelId]}
                                    legend={t(status[statusUserLevelId]) || EMPTY_VALUES.DEFAULT}
                                    classNameIcon={"w-h-24px"}
                                    className={"py-2 px-12px h-40px minh-40px maxh-40px"}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='d-flex flex-column w-100 gap-3 p-16px'>
                        {([STATUS_MODEL.PENDING, STATUS_MODEL.CHANGES_REQUESTED, STATUS_MODEL.DRAFT].includes(statusUserLevelId)
                            && (item?.description || item?.fileUploadDto?.name)
                            && showBadgeMessage)
                        && (
                                <>
                                    <CustomUserChip
                                        name={
                                            <div className={"flex-grow-1 minw-0"}>
                                                <CustomTooltip
                                                    text={item?.description || item?.fileUploadDto?.name}
                                                    showIfTruncated={true}
                                                    classes={"text-ellipsis-100"}
                                                    placement={"top"}
                                                />
                                            </div>
                                        }
                                        Icon={IconInfoCard}
                                        showAvatar={true}
                                        className={'chip-secondary-150-100 w-100 justify-content-start d-flex flex-row'}
                                        classNameIcon="icon-color-secondary-700"
                                        classNameText={"pt-1 pl-0 col-9"}
                                        variant='large'
                                        iconPosition={POSITION_MODEL.LEFT}
                                        onDelete={item?.fileUploadDto?.filePath ? () => downloadActionFile(item.fileUploadDto.filePath) : undefined}
                                        deleteIcon={
                                             item?.fileUploadDto?.filePath && (
                                            <div className={"col-3 p-0"}>
                                                <ButtonSubAction
                                                    name={"reference_file"}
                                                    Icon={IconClip}
                                                    iconProps="icon-color-secondary-700"
                                                    className="font-color-secondary-700 m-0"
                                                    onClick={() => {downloadActionFile(item?.fileUploadDto?.filePath);}}
                                                />
                                            </div>
                                             )
                                        }
                                    />
                                </>
                        )}
                        <div>
                            {((isFile && !item?.userLevel && !item?.userLevel?.fileUploadDto)) && (
                                <>
                                    <CustomFileCard
                                        downloadAtEnd
                                        showIcon={true}
                                        fileValue={item?.fileUploadDto}
                                        title={t(`upload_file`)}
                                        Icon={IconFileEmpty}
                                        showBtnDownload={false}
                                        emptyFields={!item?.fileUploadDto}
                                        extraActions={[
                                            <ButtonAction
                                                key={`btn_lrc_upload_${item?.fileUploadDto?.id}` || index}
                                                Icon={UpdateIcon}
                                                id={`btn_lrc_download_${item?.userLevel?.fileUploadDto?.fileId}`}
                                                className={'btn-outlined-secondary-600-25 btn-icon-svg-chip-button w-40px h-40px minw-40px p-0'}
                                                iconClass={'mr-0'}
                                                onClick={() => {
                                                    setShowModal(true);
                                                    setActiveLevelIndex(index);
                                                }}
                                            />
                                           ]}
                                        classContent="pb-3"
                                    />
                                </>
                            )}
                            {isText && (
                                <>
                                   <CustomTextField
                                       required={true}
                                       id={'txt_lrc_name'}
                                       name={"document"}
                                       trans={item?.name}
                                       disabled={[STATUS_MODEL.APPROVED, STATUS_MODEL.DENIED, STATUS_MODEL.PENDING_REVIEW].includes(statusUserLevelId)}
                                       length={255}
                                       value={item?.userLevel?.document || ''}
                                       onChange={(e) => {
                                           handleChange(e, index)
                                       }}
                                       emptyFields={emptyFields}
                                   />
                               </>
                            )}
                            {((isFile && item?.userLevel != null && item?.userLevel?.fileUploadDto != null)
                                || (isFile && item?.userLevel != null ))
                            && (
                                <>
                                    <CustomFileCard
                                        downloadAtEnd
                                        showIcon={true}
                                        fileValue={item?.userLevel?.fileUploadDto?.filePath}
                                        title={ !item?.userLevel?.modified && item?.userLevel?.fileUploadDto?.id ? item?.userLevel?.fileUploadDto?.name :  getFileNameWithoutExtension(item?.userLevel?.fileUpload?.name)}
                                        Icon={ !item?.userLevel?.modified && item?.userLevel?.fileUploadDto?.id  ? item?.userLevel?.fileUploadDto?.Icon  :  getFileIcon(item?.userLevel?.fileUpload?.name)}
                                        subtitle={
                                            <p className={"fs-12px ibl-font-w-400 font-color-general-950"}>
                                                {!item?.userLevel?.modified && item?.userLevel?.fileUploadDto?.id  ?
                                                    item?.userLevel?.fileUploadDto?.size
                                                    :
                                                    formatBytes(item?.userLevel?.fileUpload?.size)
                                                }
                                            </p>
                                        }
                                        showBtnDownload={false}
                                        extraActions={
                                            <div className={"d-flex gap-2"}>
                                                <ButtonAction
                                                    key={`btn_lrc_download_${item?.userLevel?.fileUploadDto?.fileId}` || index}
                                                    Icon={DownloadIcon}
                                                    id={`btn_lrc_download_${item?.userLevel?.fileUploadDto?.fileId}`}
                                                    className={'btn-outlined-secondary-600-25 btn-icon-svg-chip-button w-40px h-40px minw-40px p-0'}
                                                    iconClass={'mr-0'}
                                                    onClick={() => {
                                                        if(!item?.userLevel?.modified && item?.userLevel?.fileUploadDto?.id ){
                                                            downloadActionFile(item?.userLevel?.fileUploadDto?.filePath);
                                                        }else{
                                                            downloadLocalFile(item?.userLevel?.fileUpload)
                                                        }
                                                    }}
                                                />
                                                {[STATUS_MODEL.PENDING, STATUS_MODEL.CHANGES_REQUESTED, STATUS_MODEL.DRAFT].includes(statusUserLevelId) &&
                                                    <ButtonAction
                                                        key={`btn_lrc_upload_${item?.userLevel?.fileUploadDto?.fileId}` || index}
                                                        Icon={UpdateIcon}
                                                        id={`btn_lrc_download_${item?.userLevel?.fileUploadDto?.fileId}`}
                                                        className={'btn-outlined-secondary-600-25 btn-icon-svg-chip-button w-40px h-40px minw-40px p-0'}
                                                        iconClass={'mr-0'}
                                                        onClick={() => {
                                                            setShowModal(true);
                                                            setActiveLevelIndex(index);
                                                        }}
                                                    />
                                                }
                                            </div>
                                        }
                                        classContent="pb-3"
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};


export default LevelRequestCard
